import type { AccessRule, GroupMember, PortalRole } from '../lib/types';

/** What a group_manager may see: own groups, their members and the doors of their rules. */
export interface Scope {
  groupIds: Set<string>;
  personIds: Set<string>;
  doorIds: Set<string>;
}

export function computeScope(
  role: PortalRole,
  managedGroupIds: string[],
  members: GroupMember[],
  rules: AccessRule[],
): Scope | null {
  if (role !== 'group_manager') return null; // unrestricted within the club
  const groupIds = new Set(managedGroupIds);
  return {
    groupIds,
    personIds: new Set(members.filter((m) => groupIds.has(m.group_id)).map((m) => m.person_id)),
    doorIds: new Set(rules.filter((r) => groupIds.has(r.group_id)).map((r) => r.door_id)),
  };
}

export const inScope = (scope: Scope | null, kind: keyof Scope, id: string) => !scope || scope[kind].has(id);
